import axios from "axios";

import type { IBankAccount, IBankingDataResult } from "./types";

export interface IBankingDataAggregatedTransactionsResponse {
  accounts: IBankAccount[];
  fullMonthsPeriod: { startDate: DateString; endDate: DateString };
  results: IBankingDataResult[];
}

export const fetchBankingDataAggregatedTransactions = async (
  resourceId: number | string,
  resourceType: "GUARANTOR" | "APPLYING_COMPANY",
) => {
  return await axios.get<IBankingDataAggregatedTransactionsResponse>(
    `/api/v1/banking-data/transactions/aggregated?resourceId=${resourceId}&resourceType=${resourceType}`,
  );
};
